import React from "react";

const File: React.FC = () => (
<svg xmlns="http://www.w3.org/2000/svg" width="12" height="14" viewBox="0 0 12 14" fill="none">
  <path d="M11 4.14272L7.42857 0.571289L1 0.571306L1 13.4284L11 13.4284L11 4.14272Z" stroke="black" strokeLinecap="round" strokeLinejoin="round"/>
</svg>
);

export default File;
